export default __webpack_public_path__ + "img/qtoggle-icons.svg";